<app-header></app-header>
<app-public-register-container>
    <h5 class="card-title text-center">{{ 'Signup.SignUp' | translate }}</h5>
            <form class="login-form mt-4" [formGroup]="signupForm" (submit)="onSignup(signupForm.value)" novalidate>
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label mb-0">{{ 'Signup.FirstName' | translate }} <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i data-feather="user" class="fea icon-sm icons"></i>
                      <input type="text" class="form-control px-2" placeholder="{{ 'Signup.FirstName' | translate }}" formControlName="first_name"
                             [ngClass]="formValidator.formErrors.first_name ? 'border-danger':''">
                      <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.first_name">
                        {{ formValidator.formErrors.first_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label mb-0">{{ 'Signup.LastName' | translate }} <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i data-feather="user" class="fea icon-sm icons"></i>
                      <input type="text" class="form-control px-2" placeholder="{{ 'Signup.LastName' | translate }}" formControlName="last_name"
                             [ngClass]="formValidator.formErrors.last_name ? 'border-danger':''">
                      <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.last_name">
                        {{ formValidator.formErrors.last_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label mb-0">{{ 'Signup.BusinessName' | translate }} <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i data-feather="user" class="fea icon-sm icons"></i>
                      <input type="text" class="form-control px-2" placeholder="{{ 'Signup.BusinessName' | translate }}" formControlName="business_name"
                             [ngClass]="formValidator.formErrors.business_name ? 'border-danger':''">
                      <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.business_name">
                        {{ formValidator.formErrors.business_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label mb-0">{{ 'Signup.Email' | translate }} <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i data-feather="mail" class="fea icon-sm icons"></i>
                      <input type="email" class="form-control px-2" placeholder="{{ 'Signup.Email' | translate }}" formControlName="email"
                             [ngClass]="formValidator.formErrors.email ? 'border-danger':''">
                      <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.email">
                        {{ formValidator.formErrors.email }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label mb-0">{{ 'Signup.BusinessPhoneNumber' | translate }} <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i data-feather="phone" class="fea icon-sm icons"></i>
                      <input type="text" class="form-control px-2" placeholder="{{ 'Signup.BusinessPhoneNumber' | translate }}" formControlName="phone"
                      [ngClass]="formValidator.formErrors.phone ? 'border-danger':''">
                      <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.phone">
                        {{ formValidator.formErrors.phone }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label mb-0">{{ 'Signup.Password' | translate }} <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i data-feather="key" class="fea icon-sm icons"></i>
                      <input type="password" class="form-control px-2" placeholder="{{ 'Signup.Password' | translate }}" formControlName="password"
                             [ngClass]="formValidator.formErrors.password ? 'border-danger':''">
                      <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.password">
                        {{ formValidator.formErrors.password }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label class="form-label mb-0">{{ 'Signup.ReferralCode' | translate }}</label>
                    <div class="form-icon position-relative">
                      <i data-feather="code" class="fea icon-sm icons"></i>
                      <input type="text" class="form-control px-2"
                             placeholder="{{ 'Signup.ReferralCode' | translate }} ({{ 'Signup.Optional' | translate }})"
                             formControlName="referral_code"
                             [ngClass]="formValidator.formErrors.referral_code ? 'border-danger':''">
                      <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.referral_code">
                        {{ formValidator.formErrors.referral_code }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" formControlName="checkbox">
                      <label class="form-check-label" for="flexCheckDefault">
                        {{ 'Signup.IAccept' | translate }}
                        <a class="text-primary" routerLink="/terms">{{ 'Signup.Terms' | translate }} </a>
                        <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="text-danger fs-7" *ngIf="formValidator?.formErrors?.checkbox">
                      {{ formValidator.formErrors.checkbox }}
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="d-grid">
                    <button class="btn btn-primary" type="submit" [title]="signupForm.valid? 'Register': 'Disabled'"
                            [disabled]="signupForm.invalid">
                      {{ 'Signup.Register' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
</app-public-register-container>

<recaptcha
  [size]="'invisible'"
  [hide]="false"
>
</recaptcha>

<app-footer></app-footer>
